"use client";
import { Download } from 'lucide-react'
import { useCataloguePDF } from '@/lib/catalogue/useCataloguePDF'

interface Props {
  categorySlug: string
  useStaticPdf?: boolean
  pdfUrl?: string
}

export function DownloadCategoryCatalogueButton({ categorySlug }: Props) {
  const { generateCategoryCatalogue, isGenerating } = useCataloguePDF()

  return (
    <button
      type="button"
      className="inline-flex items-center gap-1.5 text-xs text-primary-foreground/70 hover:text-primary-foreground transition-colors px-3 py-1.5 rounded-full border border-primary-foreground/20 bg-primary-foreground/5 backdrop-blur"
      onClick={(e) => { e.preventDefault(); generateCategoryCatalogue(categorySlug) }}
      disabled={isGenerating}
    >
      <Download className="h-3 w-3" />
      PDF
    </button>
  )
}
